// extracted by mini-css-extract-plugin
export default {"story-tab-list-right-side":"StoryTabListAdminRightSide_story-tab-list-right-side__0YWYM"};